export default "__VITE_ASSET__269df747__"